import { DataType } from "../../../../../../../models/Enums";
import { Constants } from "../../../../../../../models/Constants";
import ValidationRuleModel, {
    IValidationRuleProvider,
} from "../../../../../../../models/ValidationRuleModel";

/** Drug efficacy 2.4.2 validation rules */
const ValidationRules: IValidationRuleProvider = {
    equipmentAvailabilities: new ValidationRuleModel(
        DataType.ArrayOfObject,
        false
    ),
    [`equipmentAvailabilities[${Constants.Common.IndexSubstitute}].equipment`]: new ValidationRuleModel(
        DataType.String,
        true)
};

export default ValidationRules;